module.exports = __webpack_public_path__ + "assets/img/img71.8407da83.png";